import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Spinner from "web/components/Spinner";
import Layout from "web/components/Layout";
import AlertModal from "web/components/AlertModal";
import styled from "styled-components";
import { Helmet } from "react-helmet";

const PickupOrderTC = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);

  const [modal, setModal] = useState(false);
  const toggleModal = () => setModal(!modal);
  let title = "";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Helmet title="Pickup/Delivery Orders Terms and Conditions for Pallet Buyers and Sellers | PalletTrader" >
        <meta name="description"
          content="Learn more about the pickup/delivery order terms and conditions of our marketplace. Understand the policies and guidelines for a smooth and secure buying and selling experience." />
        <meta name="robots" content="index,follow" />
        <link rel="canonical" href="https://www.pallettrader.com/checkout-terms-and-conditions" />
      </Helmet>
      <Layout pageType="Dashboard" topBarViewMobile={"hide"}>
        {loaderVisible && <Spinner />}
        <Container>
          <h3>Supplemental Terms and Conditions for Buyers and Sellers –</h3>
          <h3>Members to Buy/Sell Pallets/Products to PalletTrader+</h3>
          <TermText>
            <p><strong>Date Updated:</strong> September 30, 2025</p>
            <p>
              The following Supplemental Terms and Conditions replace the appropriate sections of the
              Terms and Conditions for Buyers and Sellers – Members accepted by the PalletTrader Member
              at the time of joining the PalletTrader Marketplace, and supplements such Terms and
              Conditions for Buyers and Sellers when the Member accepts an order to buy or sell pallets to or
              from PalletTrader+. Except as otherwise modified by these Supplemental Terms and
              Conditions, the Terms and Conditions for Buyer and Sellers – Members apply to each Pallet
              Trader+ transaction, and these Supplemental Terms and Conditions are deemed a part of, and
              incorporated in, the Terms and Conditions for Buyers and Sellers – Members with respect to
              each Pallet Trader+ transaction.
            </p>
            <p className="p-header">Pallets/Products Delivery/Pick up and Payment Processing:</p>
            <p style={{ marginTop: '5px' }}>
              When a PalletTrader Buyer/Seller accepts an Order to Buy or Sell Pallets/Products from or to
              PalletTrader+ the payments terms to Buy Pallets/Products from PalletTrader+ are ten (10) days,
              or the agreed-upon discount terms; and the payment terms to Sell Pallets/Products to
              PalletTrader+ are thirty (30) days, or the agreed-upon discount terms.
            </p>
            <p>
              After Buyer accepts an Order to Buy Pallets/Products from PalletTrader+ and picks up
              Pallets/Products from the location indicated by PalletTrader+, Buyer has 3 days to upload into
              the system the signed proof of pick up <strong>(“Pick Up Form”)</strong> provided by PalletTrader+ by the
              selling location, and to report into the Website the picked up date <strong>(“Pick Up Date”)</strong> and
              quantities and grades of Pallets picked up recorded in the Pallets Pick Up Form as per the Pallet
              Specifications included in the PalletTrader Website. Once the Pick Up Form has been uploaded
              into the Website, the PalletTrader+ administrator has 48 hours to review the Pallets/Products
              quantities and grades and file any Claims for discrepancies on Pallets/Products quantities or
              grades. If no Claim Notice was filed by the PalletTrader+ administrator, the System will
              generate an invoice <strong>(“Invoice”)</strong> to the Buyer. The System will process the Invoice payment
              within ten (10) days from the Pick Up Date using the Method of Payment selected by Buyer
              when joining PalletTrader.
            </p>
            <p>
              After Seller accepts an Order to Sell Pallets/Products to PalletTrader+ and delivers the
              Pallets/Products to the location indicated by PalletTrader+, Seller uploads into the Website the
              signed Delivery Receipt and selects the date and time of delivery of the Pallets/Products to the
              location indicated by PalletTrader+, which must match the date on the Proof of Delivery. The
              Website will record it as the delivery date/time <strong>(“Delivery Date/Time”)</strong>. The PalletTrader+
              administrator has 48 hours after the Delivery Date/Time to file any Claims. If the PalletTrader+
              administrator fails to deliver a Claim Notice within such time period, the PalletTrader+
              administrator shall be deemed to have waived any claim or objection to the purchased Pallets.
            </p>
            <p>
              PalletTrader+ will initiate payment to the Seller at thirty (30) days from the upload date, or
              according to the agreed-upon discount terms. The payment will be made after deducting any
              applicable transaction fees and taxes. It can take up to 10 Business Days after the payment was
              initiated by the PalletTrader+ administrator for Seller to receive the Funds in its Deposit Account
              and otherwise in accordance with these Supplemental Terms and Conditions.
            </p>
          </TermText>
        </Container>
        <AlertModal
          isOpen={modal}
          toggle={toggleModal}
          title={title}
          content=''
          link=''
          callBackAlert={(val) => { }}
        />
      </Layout>
    </>
  );
};

export default PickupOrderTC;

const Container = styled.div`
  max-width: 1423px;
  padding: 50px 10px;
  margin: 0 auto;
  @media (max-width: 1250px) {
    padding: 15px;
  }
  h3 {
    font-family: "latobold";
    text-align: center;
    padding: 0 50px;
  }
`;
const TermText = styled.div`
  padding: 15px 0;
  margin-top: 15px;
  p {
    text-align: justify;
    margin: 25px 0;
  }
  .p-header{
    margin-bottom: 10px !important;
    font-weight: bold;
    font-size: 18px;
  }
`;